export const stripQueryParam = function ($route, param) {
  if (process.server) return // Can't change the URL serverside without redirecting
  const query = { ...$route.query }
  delete query[param]
  const queryString = new URLSearchParams(query).toString()
  window.history.replaceState({}, '', `${$route.path}${queryString.length ? '?' : ''}${queryString}`)
}